
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sources/google-bigquery",
      function () {
        return require("private-next-pages/sources/google-bigquery.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sources/google-bigquery"])
      });
    }
  